import React from 'react'
// import About from '../Component/About'
// import AboutBreadcrumb from '../Component/AboutBreadcrumb'
import Header from '../Component/Header'
import CoursesDetailsBreadcrumb from '../Component/CoursesDetailsBreadcrumb'
import Footer from '../Component/Footer'
// import CoureseBreadcrumb from '../Component/CoureseBreadcrumb'
import Freeconsultation from '../Component/Freeconsultation'
import FAQ from '../Component/FAQ'
import CoursesDescription from '../Component/CoursesDescription'
import Blog from '../Component/Blog'

function CourseDetails() {
    return (
        <div>
            <Header />
            <CoursesDetailsBreadcrumb />
            {/* <CoureseBreadcrumb /> */}
            {/* <CourseSection /> */}
            <CoursesDescription />
            <Freeconsultation />
            <FAQ />
            <Blog />
            <Footer />
        </div>
    )
}

export default CourseDetails